import { mapActions } from 'vuex';
import Authentication from '@/mixins/Authentication';
import Loader from '@/components/Loader';
import Progress from '@/mixins/Progress';

export default {
  mixins: [
    Authentication,
    Progress,
  ],
  components: {
    Loader,
  },
  mounted() {
    this.refreshBreadcrumbs(this.breadcrumbs);
  },
  destroyed() {
    this.resetViewBreadcrumbs(this.$options.name);
  },
  computed: {
    breadcrumbs() {
      return [];
    },
  },
  watch: {
    breadcrumbs(breadcrumbs) {
      this.refreshBreadcrumbs(breadcrumbs);
    },
  },
  methods: {
    refreshBreadcrumbs(breadcrumbs) {
      const newBreadcrumbs = (breadcrumbs || []).map(breadcrumb => (
        {
          text: this.$t(`breadcrumbs.${breadcrumb.key}`),
          ...breadcrumb,
        }
      ));
      this.setViewBreadcrumbs({
        view: this.$options.name,
        breadcrumbs: newBreadcrumbs,
      });
    },
    ...mapActions([
      'setViewBreadcrumbs',
      'resetViewBreadcrumbs',
    ]),
  },
};



// WEBPACK FOOTER //
// ./mixins/View.js